module.exports = __webpack_public_path__ + "static/img/lolabunny2.7c18d6e5.png";